import { z } from "zod";

import { env } from "@/env";
import { articlesCollection } from "@/lib/strapiClient";

const strapiCoverSchema = z.object({
	url: z.string(),
	alternativeText: z.string().nullable(),
});

const strapiLocalizationSchema = z.object({
	id: z.number(),
	documentId: z.string(),
	title: z.string(),
	excerpt: z.string(),
	date: z.string(),
	category: z.string(),
	body: z.string().nullable(),
	locale: z.string(),
});

export const strapiArticleSchema = z.object({
	id: z.number(),
	documentId: z.string(),
	title: z.string(),
	excerpt: z.string(),
	date: z.string(),
	category: z.string(),
	body: z.string().nullable(),
	locale: z.string(),
	cover: strapiCoverSchema.nullable(),
	localizations: z.array(strapiLocalizationSchema).default([]),
});

export type StrapiArticle = z.infer<typeof strapiArticleSchema>;

export async function getArticles(locale = "mk-MK"): Promise<StrapiArticle[]> {
	const response = await articlesCollection.find({
		locale,
		populate: ["localizations", "cover"],
		sort: "publishedAt:desc",
	});
	return z.array(strapiArticleSchema).parse(response.data);
}

export async function getArticle(
	documentId: string,
	locale = "mk-MK",
): Promise<StrapiArticle | null> {
	try {
		const response = await articlesCollection.findOne(documentId, {
			locale,
			populate: ["localizations", "cover"],
		});
		return strapiArticleSchema.parse(response.data);
	} catch {
		return null;
	}
}

export function getCoverUrl(article: StrapiArticle): string | null {
	if (!article.cover?.url) return null;
	if (article.cover.url.startsWith("http")) return article.cover.url;
	return `${env.VITE_STRAPI_BASE_URL}${article.cover.url}`;
}
